// The M9 bayonet: "M9 Bayonet (Fade)" by Firewarden (sketchfab.com/Firewarden, CC-BY-4.0), split by
// scripts/import-m9.mjs into the grip, the guard (with its ring) and the blade. Held with the index
// finger behind the guard and the saw teeth on top; its inspect is held up in the fist, blade up,
// turned to show the flat (like CS2), not on the palm.

import * as THREE from 'three';
import { straightKnifeLoader } from './straightKnife';

export const loadM9 = straightKnifeLoader({
  url: `${import.meta.env.BASE_URL ?? '/'}assets/models/m9.glb`,
  colors: { grip: 0x0e0f12, guard: 0x1d1f24 },
  fitScale: 0.17,
  index: { part: 'guard', from: 'middle', offset: 1.2 },
  fistLength: 13,
  edgeSide: 1,
  // The fist stays about where it rests (fpArms.ts KNIFE_FIST), only the wrist turns: index finger on
  // top so the blade stands up, knuckles still forward, so the arm doesn't reach across.
  inspect: {
    fist: new THREE.Vector3(0.06, -0.08, -0.5),
    across: new THREE.Vector3(-0.2, -1, 0.05),
    knuckles: new THREE.Vector3(-0.2, 0.1, -0.95),
    palm: false,
  },
});
